/**
 * External store for 403 Forbidden state.
 *
 * Lives outside React so that the Axios response interceptor (non-React code)
 * can signal a 403 and React components can subscribe via `useSyncExternalStore`.
 *
 * When any API call returns 403, the interceptor calls `setForbidden()`.
 * AppContent subscribes to this store and renders the Forbidden error page
 * inline at the current URL.
 */

type Listener = () => void;

let isForbidden = false;
const listeners = new Set<Listener>();

function emitChange(): void {
  listeners.forEach(listener => listener());
}

export function setForbidden(): void {
  isForbidden = true;
  emitChange();
}

export function getSnapshot(): boolean {
  return isForbidden;
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Reset forbidden state. Used in tests to clean up between test cases.
 */
export function resetForbiddenStore(): void {
  isForbidden = false;
  emitChange();
}
